var programs = [
    'Promotions', 'Performance Bonus', 'Custom Initiatives',
    'Fees', 'Instant Rebates'
];
var landingPageController = (function () {
    function landingPageController(env, $filter, DTS, $stateParams, $state, socket, $scope, config, admin, $timeout, Dialog, $q, settings, $window) {
        var _this = this;
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.config = config;
        this.admin = admin;
        this.$timeout = $timeout;
        this.Dialog = Dialog;
        this.$q = $q;
        this.settings = settings;
        this.$window = $window;
        this.shouldSave = true;
        this.user = {};
        this.isShowClaimForms = false;
        this.isShowCore = false;
        this.isShowMetrics = false;
        this.socket.forward('config.userbyemail', this.$scope);
        this.$scope.$on('socket:config.userbyemail', function (event, data) {
            _this.user = data;
            var userSwdrPrograms = _.get(data, 'swdr_permissions.program', []);
            var userCFPrograms = _.get(data, 'claimforms_permissions.program', []);
            if (userSwdrPrograms.includes('SVI')) {
                _this.isShowCore = true;
                _this.isShowMetrics = true;
            }
            var isIncludesProgramType = userCFPrograms.filter(function (program) { return programs.includes(program); }).length > 0;
            if (isIncludesProgramType) {
                _this.isShowClaimForms = true;
            }
        });
    }
    landingPageController.prototype.$onInit = function () {
        this.admin.getUserProfile(this.env.user.email);
    };
    landingPageController.prototype.claim = function () {
        this.updateUserPermissions('claim-forms');
    };
    landingPageController.prototype.metrics = function () {
        this.updateUserPermissions('report');
    };
    landingPageController.prototype.core = function () {
        this.updateUserPermissions('');
    };
    landingPageController.prototype.updateUserPermissions = function (app) {
        this.user.swdr_permissions.app = app === '' ? 'core' : app;
        var saveBundle = { data: this.user };
        if (this.shouldSave) {
            this.admin.updateUserProfile(saveBundle);
        }
        this.$window.location.href = "/" + app;
    };
    landingPageController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state',
        'socket', '$scope', 'config', 'admin', '$timeout', 'Dialog', '$q', 'settings', '$window'];
    return landingPageController;
}());
var landingComponent = (function () {
    function landingComponent() {
        this.templateUrl = 'landing.html';
        this.controllerAs = 'vm';
        this.controller = landingPageController;
    }
    return landingComponent;
}());
angular
    .module('application')
    .component('landingSection', new landingComponent());

//# sourceMappingURL=landing.component.js.map
